import { createContext } from "react";
import { useTimelineZoom } from "./use-timeline-zoom";

interface TimelineSizeState {
  timelineWidth: number;
}

export const TimelineSizeContext = createContext<TimelineSizeState>({
  timelineWidth: 0,
});

type TimelineSizeProviderProps = {
  children: React.ReactNode;
  containerWidth: number;
};

const calculateTimelineWidth = ({
  timelineContainerWidth,
  zoom,
}: {
  timelineContainerWidth: number;
  zoom: number;
}) => {
  return timelineContainerWidth * zoom;
};

export const TimelineSizeProvider = ({
  children,
  containerWidth,
}: TimelineSizeProviderProps) => {
  const { zoom } = useTimelineZoom();

  const timelineWidth = calculateTimelineWidth({
    timelineContainerWidth: containerWidth,
    zoom,
  });

  return (
    <TimelineSizeContext.Provider value={{ timelineWidth }}>
      {children}
    </TimelineSizeContext.Provider>
  );
};
